import './List';

import {createApp} from "vue";
import App from './Vue/App.vue';

// Mount the Vue publication form app if the mount point exists on the page.
// The JSON config is provided by the Fluid template in a <script type="application/json"> tag.
if (document.querySelector('#lfmpub-form-app')) {
    const app = createApp(App);

    // Global click-outside directive used by FormSelect
    app.directive('click-outside', {
        mounted(el, binding) {
            el.__clickOutside = (event) => {
                if (!el.contains(event.target)) binding.value();
            };
            document.addEventListener('click', el.__clickOutside);
        },
        unmounted(el) {
            document.removeEventListener('click', el.__clickOutside);
        },
    });

    app.mount('#lfmpub-form-app');
}
